// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"603ca16fa8142a4e","5345":"7df570821880a75a"}[chunkId] + ".css";
};